import React from 'react';
import { Link } from 'react-router-dom';
import { Navbar } from '../components/Navbar';
import { Footer } from '../components/Footer';
import { ScrollReveal } from '../components/ScrollReveal';
import { ArrowRightIcon } from 'lucide-react';
export function ReferentenOverviewPage() {
  return <div className="min-h-screen bg-slate-50 font-sans text-slate-900 selection:bg-[#59d0d4]/30 selection:text-[#3b7780] flex flex-col" data-id="element-1154">
      <Navbar data-id="element-1155" />

      <main className="flex-grow pt-32 pb-20" data-id="element-1156">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1157">
          <ScrollReveal variant="up" data-id="element-1158">
            <div className="text-center max-w-3xl mx-auto mb-12 md:mb-20" data-id="element-1159">
              <span className="text-[#59d0d4] font-extrabold tracking-widest uppercase text-sm mb-4 block" data-id="element-1160">
                Lernen Sie von den Besten
              </span>
              <h1 className="text-3xl md:text-5xl lg:text-6xl font-extrabold text-slate-700 mb-6 tracking-tight" data-id="element-1161">
                Ihr Referenten-Team
              </h1>
              <p className="text-base sm:text-lg text-slate-500 font-medium leading-relaxed" data-id="element-1162">
                Kompetenz und Erfahrung für Ihre zahnärztliche Fortbildung.
                Unsere Akademie setzt auf ein ausgewähltes Team erfahrener
                Referenten, die ihr Wissen verständlich, praxisnah und mit
                Leidenschaft vermitteln.
              </p>
            </div>
          </ScrollReveal>

          <h2 className="sr-only" data-id="element-1163">Unsere Referenten</h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-10" data-id="element-1164">
            {/* Speaker 1 */}
            <ScrollReveal variant="scale" delay={100} data-id="element-1165">
              <div className="bg-white rounded-3xl overflow-hidden shadow-lg border border-slate-100 hover:shadow-2xl transition-all duration-500 group flex flex-col h-full" data-id="element-1166">
                <div className="aspect-square overflow-hidden relative" data-id="element-1167">
                  <img src="https://cdn.rawproductionsgmbh.de/2n/home/schwenk.jpg" alt="Dr. Thomas Schwenk" className="w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-110" data-id="element-1168" />
                  <div className="absolute inset-0 bg-gradient-to-t from-slate-900/80 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" data-id="element-1169"></div>
                </div>
                <div className="p-5 sm:p-8 relative bg-white flex flex-col flex-grow" data-id="element-1170">
                  <h3 className="text-xl sm:text-2xl font-extrabold text-slate-700 mb-2" data-id="element-1171">
                    Dr. Thomas Schwenk
                  </h3>
                  <p className="text-[#3b7780] font-bold text-sm mb-4 sm:mb-6 uppercase tracking-wider" data-id="element-1172">
                    Spezialist für Ästhetik und Funktion (DGÄZ)
                  </p>
                  <ul className="space-y-3 mb-6 sm:mb-8 text-sm text-slate-500 font-medium flex-grow" data-id="element-1173">
                    <li className="flex items-start" data-id="element-1174">
                      <span className="w-1.5 h-1.5 rounded-full bg-[#59d0d4] mt-1.5 mr-3 flex-shrink-0" data-id="element-1175"></span>
                      Spezialist für Ästhetik & Funktion (DGÄZ)
                    </li>
                    <li className="flex items-start" data-id="element-1176">
                      <span className="w-1.5 h-1.5 rounded-full bg-[#59d0d4] mt-1.5 mr-3 flex-shrink-0" data-id="element-1177"></span>
                      Zahnarzttrainer seit 1998
                    </li>
                    <li className="flex items-start" data-id="element-1178">
                      <span className="w-1.5 h-1.5 rounded-full bg-[#59d0d4] mt-1.5 mr-3 flex-shrink-0" data-id="element-1179"></span>
                      Ausgezeichnet zum Dentrepreneur 2024
                    </li>
                  </ul>
                  <Link to="/referenten/dr-thomas-schwenk" className="inline-flex items-center text-[#3b7780] font-extrabold hover:text-[#59d0d4] transition-colors group/link mt-auto" data-id="element-1180">
                    Mehr erfahren{' '}
                    <ArrowRightIcon className="ml-2 w-5 h-5 transform group-hover/link:translate-x-1 transition-transform" data-id="element-1181" />
                  </Link>
                </div>
              </div>
            </ScrollReveal>

            {/* Speaker 2 */}
            <ScrollReveal variant="scale" delay={200} data-id="element-1182">
              <div className="bg-white rounded-3xl overflow-hidden shadow-lg border border-slate-100 hover:shadow-2xl transition-all duration-500 group flex flex-col h-full" data-id="element-1183">
                <div className="aspect-square overflow-hidden relative" data-id="element-1184">
                  <img src="https://cdn.rawproductionsgmbh.de/2n/home/striegel.jpg" alt="Dr. Markus Striegel" className="w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-110" data-id="element-1185" />
                  <div className="absolute inset-0 bg-gradient-to-t from-slate-900/80 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" data-id="element-1186"></div>
                </div>
                <div className="p-5 sm:p-8 relative bg-white flex flex-col flex-grow" data-id="element-1187">
                  <h3 className="text-xl sm:text-2xl font-extrabold text-slate-700 mb-2" data-id="element-1188">
                    Dr. Markus Striegel
                  </h3>
                  <p className="text-[#3b7780] font-bold text-sm mb-4 sm:mb-6 uppercase tracking-wider" data-id="element-1189">
                    Spezialist für Ästhetik und Funktion (DGÄZ)
                  </p>
                  <ul className="space-y-3 mb-6 sm:mb-8 text-sm text-slate-500 font-medium flex-grow" data-id="element-1190">
                    <li className="flex items-start" data-id="element-1191">
                      <span className="w-1.5 h-1.5 rounded-full bg-[#59d0d4] mt-1.5 mr-3 flex-shrink-0" data-id="element-1192"></span>
                      Vizepräsident DGSZM e.V.
                    </li>
                    <li className="flex items-start" data-id="element-1193">
                      <span className="w-1.5 h-1.5 rounded-full bg-[#59d0d4] mt-1.5 mr-3 flex-shrink-0" data-id="element-1194"></span>
                      Zahnarzttrainer seit 1998
                    </li>
                    <li className="flex items-start" data-id="element-1195">
                      <span className="w-1.5 h-1.5 rounded-full bg-[#59d0d4] mt-1.5 mr-3 flex-shrink-0" data-id="element-1196"></span>
                      Ausgezeichnet zum Dentrepreneur 2024
                    </li>
                  </ul>
                  <Link to="/referenten/dr-markus-striegel" className="inline-flex items-center text-[#3b7780] font-extrabold hover:text-[#59d0d4] transition-colors group/link mt-auto" data-id="element-1197">
                    Mehr erfahren{' '}
                    <ArrowRightIcon className="ml-2 w-5 h-5 transform group-hover/link:translate-x-1 transition-transform" data-id="element-1198" />
                  </Link>
                </div>
              </div>
            </ScrollReveal>

            {/* Speaker 3 */}
            <ScrollReveal variant="scale" delay={300} data-id="element-1199">
              <div className="bg-white rounded-3xl overflow-hidden shadow-lg border border-slate-100 hover:shadow-2xl transition-all duration-500 group flex flex-col h-full" data-id="element-1200">
                <div className="aspect-square overflow-hidden relative" data-id="element-1201">
                  <img src="https://cdn.rawproductionsgmbh.de/2n/home/herzog.jpg" alt="Dr. Johanna Herzog" className="w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-110" data-id="element-1202" />
                  <div className="absolute inset-0 bg-gradient-to-t from-slate-900/80 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" data-id="element-1203"></div>
                </div>
                <div className="p-5 sm:p-8 relative bg-white flex flex-col flex-grow" data-id="element-1204">
                  <h3 className="text-xl sm:text-2xl font-extrabold text-slate-700 mb-2" data-id="element-1205">
                    Dr. Johanna Herzog M.Sc.
                  </h3>
                  <p className="text-[#3b7780] font-bold text-sm mb-4 sm:mb-6 uppercase tracking-wider" data-id="element-1206">
                    Fokus auf Kieferorthopädie & Funktion
                  </p>
                  <ul className="space-y-3 mb-6 sm:mb-8 text-sm text-slate-500 font-medium flex-grow" data-id="element-1207">
                    <li className="flex items-start" data-id="element-1208">
                      <span className="w-1.5 h-1.5 rounded-full bg-[#59d0d4] mt-1.5 mr-3 flex-shrink-0" data-id="element-1209"></span>
                      Vizepräsidentin Dentista e.V.
                    </li>
                    <li className="flex items-start" data-id="element-1210">
                      <span className="w-1.5 h-1.5 rounded-full bg-[#59d0d4] mt-1.5 mr-3 flex-shrink-0" data-id="element-1211"></span>
                      Generalsekretärin bei der DGSZM
                    </li>
                    <li className="flex items-start" data-id="element-1212">
                      <span className="w-1.5 h-1.5 rounded-full bg-[#59d0d4] mt-1.5 mr-3 flex-shrink-0" data-id="element-1213"></span>
                      Referentin für Align, APW und DGSZM
                    </li>
                  </ul>
                  <Link to="/referenten/dr-johanna-herzog" className="inline-flex items-center text-[#3b7780] font-extrabold hover:text-[#59d0d4] transition-colors group/link mt-auto" data-id="element-1214">
                    Mehr erfahren{' '}
                    <ArrowRightIcon className="ml-2 w-5 h-5 transform group-hover/link:translate-x-1 transition-transform" data-id="element-1215" />
                  </Link>
                </div>
              </div>
            </ScrollReveal>
          </div>

          <ScrollReveal variant="up" delay={400} data-id="element-1216">
            <div className="mt-16 text-center" data-id="element-1217">
              <p className="text-slate-500 font-bold text-base sm:text-lg" data-id="element-1218">
                Gemeinsam stehen sie für höchste Qualität und begleiten Sie auf
                Ihrem individuellen Fortbildungsweg.
              </p>
            </div>
          </ScrollReveal>
        </div>
      </main>

      <Footer data-id="element-1219" />
    </div>;
}